import { render, staticRenderFns } from "./PaginationView.vue?vue&type=template&id=aa12399c&scoped=true&"
import script from "./PaginationView.vue?vue&type=script&lang=js&"
export * from "./PaginationView.vue?vue&type=script&lang=js&"
import style0 from "./PaginationView.vue?vue&type=style&index=0&id=aa12399c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa12399c",
  null
  
)

export default component.exports